export class MassiveProcess{
    id : string;
    type : string;
    status : string;
    registerDate : Date;
    finishDate : Date;
    fileUrl : string;
    finalMessage : string;
    notificationSent : boolean;
    detail : MassiveProcessConfiguration;
    boUserId : string;
    projectId : string;
    validationStatus : string;
    validationDetails : ValidationDetails | null;
}

export class ValidationDetails{
    columnsNotFound : string[] | null;
    columnsWithErrors : string[] | null;
    allErrors : string[] | null;
}

export class MassiveProcessConfiguration{

}

export enum MassiveProcessType {
    CLIENT_PROCESS_TYPE = 'C',
    PAYMENT_ORDER_TYPE = 'P',
    PAYMENT_ACTION_TYPE = 'R',
    RECOVERY_CAMPAIGN_TYPE = 'V',
    RECOVERY_CAMPAIGN_PAYMENT_ACTION_TYPE = 'A',
}